'use strict';

module.exports = /*@ngInject*/
function() {
    return {
        link: function(scope, element, attrs) {
            // TODO: remove jquery!
            jQuery(window).scroll(function() {
                if(jQuery(this).scrollTop() > 50) {
                    if (!jQuery('#toTop').hasClass('enroute')) {
                        jQuery('#toTop').addClass('showing');
                    }
                } else {
                    jQuery('#toTop').removeClass('showing enroute');
                }
            });

            jQuery('#toTop').click(function() {
                jQuery('#toTop')
                    .removeClass('showing')
                    .addClass('enroute');

                jQuery('body, html').animate({ scrollTop: 0 }, 800);
            });
        }
    };
};
